export default "__VITE_ASSET__BtWD4GBS__"